import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as moviesBundlesModel from './model'

export function Title(): JSX.Element {
  return <AppTitle t='extras' />
}

const skin = era.skin('routes/movies/bundles')

MovieBundlesPage.displayName = 'MovieBundlesPage'
export function MovieBundlesPage(): JSX.Element {
  const isContentLoading = useUnit(moviesBundlesModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <Skeleton pageType='bundle' isLoading={isContentLoading}>
          <ui.RenderSkin name='bundle' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
